import React from "react";
import Mousetrap from "mousetrap";

class AddEditModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      entityName: props.modalData.entityName || "",
      entityId: props.modalData.id || "",
      parentId: props.modalData.parentId
    };
    Mousetrap.bind("escape", this.props.close);
  }
  checkIfEscape = e => {
    if (e.key === "Escape") this.props.close();
  };
  render() {
    const { entityId, entityName, parentId } = this.state;
    const { modalType, cb, close, Graph } = this.props;
    const parentNames = Object.keys(Graph.graphIdMapping)
      .map(id => {
        if (id === entityId) return undefined;
        return { id, name: Graph.graphIdMapping[id].entityName };
      })
      .filter(x => x);
    return (
      <form
        onSubmit={() => {
          close();
          cb(entityName, parentId);
        }}
        action="#"
      >
        <input
          type="text"
          autoFocus
          required
          placeholder="* Entity name"
          value={entityName}
          onKeyUp={this.checkIfEscape}
          onChange={e => this.setState({ entityName: e.target.value })}
        />
        <select
          placeholder="* Parent"
          required
          disabled={parentId === null}
          value={parentId || ""}
          onKeyUp={this.checkIfEscape}
          onChange={e => this.setState({ parentId: e.target.value })}
        >
          {parentNames.map(p => (
            <option value={p.id} key={p.id}>
              {p.name}
            </option>
          ))}
        </select>
        <div className="clearfix">
          <button type="submit" className="float-left">
            {modalType === "edit" ? "Update" : "Add"}
          </button>
          <button type="reset" onClick={close} className="float-right">
            Cancel
          </button>
        </div>
      </form>
    );
  }
}

export default AddEditModal;
